import React from "react";

/**
 * SectionHeader with big faded section number (like reference "05 STREET PHOTOGRAPHY")
 */
export default function SectionHeader({ number, tag, title, kicker, align = "left" }) {
  return (
    <div className={`mb-16 md:mb-20 flex ${align === "center" ? "items-center text-center flex-col" : "items-start"}`}>
      <div className="flex items-baseline gap-4 md:gap-6">
        <span
          className="section-number"
          style={{ fontSize: "clamp(3.5rem, 8vw, 7rem)" }}
          data-testid={`section-number-${number}`}
        >
          {number}
        </span>
        <div className="flex flex-col">
          <span className="text-[10px] md:text-xs uppercase tracking-[0.35em] text-[#D4AF37] font-display mb-3">
            {tag}
          </span>
          <h2
            className="font-display font-bold uppercase leading-[0.95] tracking-tight text-white"
            style={{ fontSize: "clamp(1.9rem, 4.5vw, 3.5rem)" }}
          >
            {title}
          </h2>
          {kicker && (
            <p className="mt-4 max-w-xl text-[#B3B3B3] text-base leading-relaxed">
              {kicker}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
